

import BasicState from "src/libs/basic-view"
import UserResultsForm from "./user-results/UserResultsForm"

export default class UserResultsView extends BasicState {
    props: any
    addRender = () => {
        return <div className="d-flex w-100 m-0 position-relative">
            <UserResultsForm {...this.props} />  
        </div>
    }
}